import { defineStore } from 'pinia'
import { ref } from 'vue'

interface ModalStepState {
  modalHeader: string
  active: boolean
}

interface ModalContentSteps {
  step1: ModalStepState
  step2: ModalStepState
}

const createInitialSteps = (): ModalContentSteps => ({
  step1: {
    modalHeader: ' ',
    active: true
  },
  step2: {
    modalHeader: 'Select area',
    active: false
  }
})

export const useSharedStateForComponents = defineStore('sharedStateForComponents', () => {
  const isAutofocusForSearchActive = ref<boolean>(false)
  const currentModalContentSteps = ref<ModalContentSteps>(createInitialSteps())

  const setStep1ForImageFlow = () => {
    currentModalContentSteps.value.step1.active = true
    currentModalContentSteps.value.step2.active = false
  }

  const setStep2ForImageFlow = () => {
    currentModalContentSteps.value.step1.active = false
    currentModalContentSteps.value.step2.active = true
  }

  return {
    isAutofocusForSearchActive,
    currentModalContentSteps,
    setStep1ForImageFlow,
    setStep2ForImageFlow
  }
})

